import { BrowserRouter, useLocation } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import AppRoutes from "./config/routes";
import Footer from "./components/Footer";
import Header from "./components/Header";
import { useEffect, useState } from "react";
import { loadMatomo, trackPageView } from "./matomo";
import { messages } from "./config/messages";
import CookieConsent from "react-cookie-consent";
import theme from "./theme";
import { Typography } from "@mui/material";
import { TranslatorProvider } from "./context/TranslatorContext";

function MatomoTracker({ trackingEnabled }) {
  const location = useLocation();

  useEffect(() => {
    if (!trackingEnabled) return;
    // load the Matomo script once
    loadMatomo();
    // track the first page view
    trackPageView(location.pathname);
  }, [trackingEnabled]);

  // track page view on route change
  useEffect(() => {
    if (trackingEnabled) {
      trackPageView(location.pathname);
    }
  }, [location.pathname, trackingEnabled]);

  return null;
}

function App() {
  const [trackingEnabled, setTrackingEnabled] = useState(
    () => document.cookie.includes("CookieConsent=true")
  );
  const [before, after] = messages.matomoHelpText.split("{cookiePolicyBannerLinkText}");
  const currentPath = window.location.pathname; // e.g., "/catalogue/somepage"
  const basePath = currentPath.split("/")[1] ? `/${currentPath.split("/")[1]}` : "";

  return (
    <>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <TranslatorProvider>
          <BrowserRouter basename="/catalogue/">
            <MatomoTracker trackingEnabled={trackingEnabled} />
            <Header />
            <AppRoutes />
            <Footer />
          </BrowserRouter>
        </TranslatorProvider>
      </ThemeProvider>
      <CookieConsent
        enableDeclineButton
        buttonText={messages.matomoAcceptButtonText}
        declineButtonText={messages.matomoDeclineButtonText}
        cookieName="CookieConsent" // important to use this name also when we undet the cookie
        onAccept={() => setTrackingEnabled(true)}
        onDecline={() => setTrackingEnabled(false)}
        expires={182} // expires in 365 days
      >
        <Typography variant="body2">
          {before}
          <a
            href={`${basePath}/cookie-policy`}
            style={{
              textDecoration: "underline",
              color: "inherit",
              cursor: "pointer",
            }}
          >
            {messages.cookiePolicyLinkText}
          </a>
          {after}
        </Typography>
      </CookieConsent>
    </>
  );
}

export default App;